import { Copy } from 'lucide-react';
import useCopyToClipboard from '../hooks/useCopyToClipboard';
import { copyServerIp } from '../lib/copyServerIp';
import { SERVER_IP } from '../config/links';

/**
 * The server address in the header, click to copy. This is a Minecraft server:
 * getting the address onto the clipboard is the single most common thing a
 * visitor wants to do.
 */
const CopyIp = () => {
  const copy = useCopyToClipboard();

  return (
    <button
      type="button"
      className="copy-ip"
      onClick={() => copyServerIp(copy)}
      aria-label={`Copy server IP ${SERVER_IP}`}
    >
      <span>IP: {SERVER_IP}</span>
      <Copy className="copy-ip__icon" aria-hidden="true" />
    </button>
  );
};

export default CopyIp;
